import { useNavigate, useParams, useSearchParams } from 'react-router-dom'
import HelpPanel from '../../components/Help/HelpPanel'
import styles from '../../components/Help/Help.module.scss'

// Public page, works without signing in. ?platform=portal&context=extensions
const HelpPage = () => {
  const { slug } = useParams()
  const [params] = useSearchParams()
  const navigate = useNavigate()

  const handleSlugChange = (value) => {
    const query = params.toString()
    navigate({ pathname: value ? `/help/${value}` : '/help', search: query ? `?${query}` : '' })
  }

  return (
    <div className={styles.pageWrapper}>
      <h1 className={styles.pageTitle}>Help</h1>
      <HelpPanel
        platform={params.get('platform') || undefined}
        context={params.get('context') || undefined}
        slug={slug}
        onSlugChange={handleSlugChange}
      />
    </div>
  )
}

export default HelpPage
